/**
 * Origin99 — GSAP + ScrollTrigger Animations
 * Seed-inspired scroll-driven storytelling
 *
 * Strategy: GSAP sets initial states via fromTo() so
 * content is always visible (progressive enhancement).
 */
(function () {
  'use strict';

  function initAnimations() {
    // Wait for GSAP and ScrollTrigger
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      // Retry up to 10 times (500ms total) since scripts load with defer
      if (!window._o99RetryCount) window._o99RetryCount = 0;
      window._o99RetryCount++;
      if (window._o99RetryCount < 10) {
        setTimeout(initAnimations, 50);
      } else {
        console.warn('Origin99: GSAP failed to load after 500ms. Page renders without animations.');
      }
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // ─── Fade Up ───
    gsap.utils.toArray('.o99-fade-up').forEach(function (el) {
      gsap.fromTo(el,
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 0.9,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none none',
            once: true
          }
        }
      );
    });

    // ─── Fade In ───
    gsap.utils.toArray('.o99-fade-in').forEach(function (el) {
      gsap.fromTo(el,
        { opacity: 0 },
        {
          opacity: 1,
          duration: 1.2,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none none',
            once: true
          }
        }
      );
    });

    // ─── Hero stagger animation ───
    var heroContent = document.querySelector('.origin99-hero__content');
    if (heroContent) {
      var heroChildren = heroContent.children;
      // Set initial state
      gsap.set(heroChildren, { opacity: 0, y: 30 });
      gsap.to(heroChildren, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.15,
        ease: 'power3.out',
        delay: 0.3
      });
    }

    // ─── Ingredient cards stagger ───
    gsap.utils.toArray('.origin99-ingredients-grid').forEach(function (grid) {
      var cards = grid.querySelectorAll('.origin99-ingredient-icon');
      gsap.fromTo(cards,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.12,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: grid,
            start: 'top 80%',
            toggleActions: 'play none none none',
            once: true
          }
        }
      );
    });

    // ─── Parallax on product images ───
    gsap.utils.toArray('.origin99-hero__media img, .origin99-cta__media img').forEach(function (img) {
      gsap.to(img, {
        y: -30,
        ease: 'none',
        scrollTrigger: {
          trigger: img.parentElement,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1
        }
      });
    });

    // ─── Refresh on section change (Shopify editor) ───
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        ScrollTrigger.refresh();
      });
      document.addEventListener('shopify:block:select', function () {
        ScrollTrigger.refresh();
      });
    }
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }
})();
